import { ChangeDetectorRef, Component, ElementRef, Input, SimpleChanges, ViewChild } from '@angular/core';
import { SocketService } from '../../../services/common/socket.service';
import { BookingService } from '../../../services/booking/booking.service';
import { BookingSyncService } from '../../../services/booking-sync/booking-sync.service';
import { DatePipe } from '@angular/common';
import { SnackbarService } from '../../../services/common/snackbar.service';

@Component({
  selector: 'app-helper-chat',
  templateUrl: './helper-chat.component.html',
  styleUrl: './helper-chat.component.scss'
})
export class HelperChatComponent {
  @Input() chatDataReceived: any | {};
  @ViewChild('chatContainer') chatContainer!: ElementRef;
  receiveMsg: any = {};
  sendMsg: String = '';
  messages: any[] = [];
  receiveMsgData: any = [];

  constructor(
    private socketServ: SocketService,
    private bookingServ: BookingService,
    private bookingSyncServ: BookingSyncService,
    private datePipe: DatePipe,
    private snackbarServ: SnackbarService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.bookingSyncServ.getHelperDataForChat().subscribe(res => {
      this.receiveMsgData = res;
      if (res?.orderId && res?.helperId) {
        this.fetchOldChats();
      }
      this.cdr.detectChanges();
    });


    this.socketServ.listen('receiveMessage').subscribe((data: any) => {
      this.receiveMsgData = { ...this.receiveMsgData, ...data };

      let formattedTime = this.convertUtcToLocalTime(data.sent_at);

      let newData = { ...data, sent_at: formattedTime };
      this.messages = [...this.messages, newData];
      this.scrollToBottom();
      this.cdr.markForCheck();
      this.cdr.detectChanges();
    });

  }

  ngAfterViewInit() {
    this.scrollToBottom();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['messages'] && changes['messages'].currentValue) {
      this.scrollToBottom();
    }
  }
  sendMessage() {
    if (this.sendMsg && this.sendMsg.length > 200) {
      this.snackbarServ.showError("Message cannot exceed 200 characters.");
      return;
    }

    if (this.sendMsg.trim()) {
      const now = new Date();

      let msg = {
        to: this.receiveMsgData?.helperId,
        to_user_id: this.receiveMsgData?.helperId,
        to_user_detail_id: this.receiveMsgData?.helper_user_detail_id,
        user_detail_id: this.receiveMsgData?.userId,
        text: this.sendMsg,
        order_id: this.receiveMsgData?.orderId,
        sent_at: this.datePipe.transform(now, 'yyyy-MM-dd HH:mm:ss') || '',
        original: '',
        thumbnail: '',
        chat_type: 'text'
      };

      this.bookingServ.sendHelperMessage(msg).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.messages.push(msg);
            this.cdr.markForCheck();
            this.cdr.detectChanges();
            this.fetchOldChats();
            this.scrollToBottom();
          } else {
            this.snackbarServ.showError(res.msg);
          }
        },

        error: (err) => {
          console.error('Send helper message API error:', err);

          if (err.status === 0) {
            this.snackbarServ.showError(
              'Network error. Please check your internet connection.'
            );
          } else {
            this.snackbarServ.showError(
              'Failed to send message. Please try again.'
            );
          }
        }
      });

      this.sendMsg = '';
      this.scrollToBottom();

    } else {
      console.warn('Cannot send an empty message.');
    }
  }


  // get all the previous chats
  fetchOldChats() {
    let payload = {
      order_id: this.receiveMsgData?.orderId,
      receiver_id: this.receiveMsgData?.helperId,
      limit: 100,
      skip: 0
    }
    if (!payload.order_id || !payload.receiver_id) {
      return;
    }
    this.bookingServ.fetchOldHelperChat(payload).subscribe((res: any) => {
      if (res.success) {
        this.messages = res.result.map((message: any) => ({
          ...message,
          sent_at: this.convertUtcToLocalTime(message.sent_at)
        }));
        this.scrollToBottom();
        this.cdr.markForCheck();
      } else {
        this.snackbarServ.showError(res.msg);
      }
    }
    );
  }
  scrollToBottom(): void {
    setTimeout(() => {
      try {
        this.chatContainer.nativeElement.scrollTop = this.chatContainer.nativeElement.scrollHeight;
      } catch (err) {
        // console.error('Scroll Error:', err);
      }
    }, 100);
  }

  convertUtcToLocalTime(utcTime: string): string {
    if (!utcTime) return "";

    let dateStr = utcTime;
    if (!dateStr.endsWith('Z') && !dateStr.includes('+') && !dateStr.toUpperCase().includes('UTC')) {
      if (dateStr.includes('T')) {
        dateStr += 'Z';
      } else {
        dateStr += ' UTC';
      }
    }

    let dateObj = new Date(dateStr);
    if (isNaN(dateObj.getTime())) {
      return utcTime;
    }

    return this.datePipe.transform(dateObj, 'yyyy-MM-dd HH:mm:ss') || '';
  }
}
